/** Possible feature values. */
export const Feature = {
    Friends: 'FRIENDS',
    Itinerary: 'ITINERARY',
    Mticket: 'MTICKET',
    Realtime: 'REALTIME',
    Reporting: 'REPORTING',
    Shop: 'SHOP',
    TextToSpeech: 'TEXT_TO_SPEECH',
    Poi: 'POI',
    Parking: 'PARKING',
    Bss: 'BSS',
    Carpooling: 'CARPOOLING',
    Hours: 'HOURS',
    Scooter: 'SCOOTER'
}

/** Normalized transport modes */
export const PhysicalMode = {
    Air: 'AIR',
    Bike: 'BIKE',
    BikeSharingService: 'BIKE_SHARING_SERVICE',
    Boat: 'BOAT',
    Bus: 'BUS',
    BusRapidTransit: 'BUS_RAPID_TRANSIT',
    Car: 'CAR',
    Checkin: 'CHECKIN',
    Checkout: 'CHECKOUT',
    Coach: 'COACH',
    Ferry: 'FERRY',
    Funicular: 'FUNICULAR',
    LocalTrain: 'LOCAL_TRAIN',
    LongDistanceTrain: 'LONG_DISTANCE_TRAIN',
    Metro: 'METRO',
    Na: 'NA',
    RailShuttle: 'RAIL_SHUTTLE',
    RapidTransit: 'RAPID_TRANSIT',
    Shuttle: 'SHUTTLE',
    SuspendedCableCar: 'SUSPENDED_CABLE_CAR',
    Taxi: 'TAXI',
    Train: 'TRAIN',
    Tramway: 'TRAMWAY'
}

/** Transfer type */
export const TransferType = {
    PublicTransport: 'PUBLIC_TRANSPORT',
    StreetNetwork: 'STREET_NETWORK',
    Waiting: 'WAITING',
    StayIn: 'STAY_IN',
    Transfer: 'TRANSFER',
    CrowFly: 'CROW_FLY',
    OnDemandTransport: 'ON_DEMAND_TRANSPORT',
    BssRent: 'BSS_RENT',
    BssPutBack: 'BSS_PUT_BACK',
    Boarding: 'BOARDING',
    Landing: 'LANDING',
    Alighting: 'ALIGHTING',
    Park: 'PARK',
    Ridesharing: 'RIDESHARING'
}

/** Traveler type used to define speeds and accessibility values for different kind of people */
export const TravelerType = {
    Standard: 'STANDARD',
    SlowWalker: 'SLOW_WALKER',
    FastWalker: 'FAST_WALKER',
    Luggage: 'LUGGAGE',
    Wheelchair: 'WHEELCHAIR'
}

export const SpecificCommercialType = {
    TER: 'TER',
    CAR_TER: 'Car TER'
}

export const CommercialMode = {
    Bus: Theme.themeURL + '/assets/dist/images/type/BUS.svg',
    Metro: Theme.themeURL + '/assets/dist/images/type/METRO.svg',
    Tramway: Theme.themeURL + '/assets/dist/images/type/TRAMWAY.svg',
    Train: Theme.themeURL + '/assets/dist/images/type/TRAIN_station.svg',
    Ter: Theme.themeURL + '/assets/dist/images/type/TRAIN_station.svg',
    Eurostar: Theme.themeURL + '/assets/dist/images/type/EUROSTAR.svg',
    Funicular: Theme.themeURL + '/assets/dist/images/type/FUNICULAR.svg',
    Lyria: Theme.themeURL + '/assets/dist/images/type/LYRIA.svg',
    Ouigo: Theme.themeURL + '/assets/dist/images/type/OUIGO.svg',
    TGV_INOUI: Theme.themeURL + '/assets/dist/images/type/TGV_INOUI.svg',
    Thalys: Theme.themeURL + '/assets/dist/images/type/THALYS.svg',
    Trottinette: Theme.themeURL + '/assets/dist/images/type/TROTTINETTE.svg',
    Bike: Theme.themeURL + '/assets/dist/images/type/BIKE.svg',
}

